var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EuiContainer',[_c('TemplateParapherEdit',{attrs:{"signBook":_vm.parapher,"fromTab":_vm.fromTab},on:{"reload":function($event){return _vm.getSignBookById(_vm.signBookId)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }